import year2001 from '../assets/migrants-2001.png';
import year2006 from '../assets/migrants-2006.png';
import year2011 from '../assets/migrants-2011.png';
import year2016 from '../assets/migrants-2016.png';
import mortality from '../assets/migrants-mortality.png';

export default { year2001, year2006, year2011, year2016, mortality };
